export default {"src":"/_next/static/media/green_down.99dc62c4.svg","height":20,"width":14,"blurWidth":0,"blurHeight":0};